import { Api } from "src/utils/api";
import { INVENTORY_METRICS_API_BASE_URL } from "./inventory.const";

export type DatePeriod = "DAY" | "WEEK" | "MONTH";

export interface APIMetricsItem {
  date: string;
  available_stock: number;
  in_transit: number;
  receiving: number;
  safety_stock: number;
}

export interface APIMetricsResponse {
  daily_metrics: APIMetricsItem[];
  total_metrics?: {
    available_stock: number;
    in_transit: number;
    receiving: number;
  };
}

export class InventoryMetricsApi extends Api {
  constructor() {
    super(INVENTORY_METRICS_API_BASE_URL);
  }

  private formatDate(input: string | Date): string {
    const d = typeof input === "string" ? new Date(input) : input;
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  }

  public async getInventory(
    dateStart: string | Date,
    dateEnd: string | Date,
    asinFilter?: string | string[],
  ): Promise<APIMetricsResponse> {
    const formattedStart = this.formatDate(dateStart);
    const formattedEnd = this.formatDate(dateEnd);

    const params: Record<string, string> = {
      date_start: formattedStart,
      date_end: formattedEnd,
    };

    if (
      asinFilter !== undefined &&
      asinFilter !== null &&
      ((typeof asinFilter === "string" && asinFilter.trim() !== "") ||
        (Array.isArray(asinFilter) && asinFilter.length > 0))
    ) {
      params.asin = Array.isArray(asinFilter)
        ? asinFilter.join(",")
        : asinFilter;
    }

    const query = new URLSearchParams(params).toString();
    const response = await this.get<APIMetricsResponse>(`/metrics?${query}`);
    return response;
  }

  public async getInventoryByBrand(
    dateStart: string | Date,
    dateEnd: string | Date,
    brandFilter?: string | string[],
  ): Promise<APIMetricsResponse> {
    const formattedStart = this.formatDate(dateStart);
    const formattedEnd = this.formatDate(dateEnd);

    const params: Record<string, string> = {
      date_start: formattedStart,
      date_end: formattedEnd,
    };

    if (
      brandFilter !== undefined &&
      brandFilter !== null &&
      ((typeof brandFilter === "string" && brandFilter.trim() !== "") ||
        (Array.isArray(brandFilter) && brandFilter.length > 0))
    ) {
      params.brand = Array.isArray(brandFilter)
        ? brandFilter.join(",")
        : brandFilter;
    }

    const query = new URLSearchParams(params).toString();
    const response = await this.get<APIMetricsResponse>(
      `/metrics/brand?${query}`,
    );
    return response;
  }
}
